(() => {
  if (window.elySurfaceFinishing) {window.elySurfaceFinishing.init(document);return;}
  const controllers = new Map();
  function init(scope) {
    const roots = [...scope.querySelectorAll('[data-mfg-surface-finishing]')];
    if (scope.matches?.('[data-mfg-surface-finishing]')) roots.unshift(scope);
    roots.forEach(root => {
      if (controllers.has(root)) return;
      const controller = new AbortController();
      const {signal} = controller;
      controllers.set(root,controller);
      const items = [...root.querySelectorAll('[data-finish]')];
      const frame = root.querySelector('.mfg-sf-photo');
      const failure = frame.querySelector('.mfg-sf-photo-error');
      let main = frame.querySelector('[data-mfg-sf-photo]');
      let revision = 0;
      const cache = new Map();
      function prepare(item) {
        const key=item.dataset.finish;
        if(cache.has(key)) return cache.get(key);
        const source=item.querySelector('.mfg-sf-mobile-photo');
        const image=new Image();
        image.alt=source.alt;image.width=source.width;image.height=source.height;
        image.decoding='async';
        if(source.sizes) image.sizes=source.sizes;
        if(source.srcset) image.srcset=source.srcset;
        image.src=source.src;
        const ready=image.decode().then(()=>image).catch(()=>{cache.delete(key);return null});
        cache.set(key,ready);return ready;
      }
      async function changePhoto(item) {
        const current=++revision;
        frame.setAttribute('aria-busy','true');
        const next=await prepare(item);
        if(signal.aborted || current!==revision) return;
        frame.setAttribute('aria-busy','false');
        if(!next){failure.hidden=false;return;}
        failure.hidden=true;next.setAttribute('data-mfg-sf-photo','');
        frame.classList.remove('is-changing');
        if(main!==next) main.replaceWith(next);
        main=next;
        requestAnimationFrame(()=>{if(!signal.aborted && current===revision) frame.classList.add('is-changing')});
      }
      function setOpen(item,open) {
        item.classList.toggle('is-open',open);
        item.querySelector('.mfg-sf-trigger').setAttribute('aria-expanded',String(open));
        item.querySelector('.mfg-sf-content').hidden=!open;
      }
      items.forEach(item=>{
        const button=item.querySelector('.mfg-sf-trigger');
        const mobile=item.querySelector('.mfg-sf-mobile-photo');
        let mobileError=item.querySelector('.mfg-sf-mobile-error');
        if(!mobileError){mobileError=document.createElement('p');mobileError.className='mfg-sf-mobile-error';mobileError.setAttribute('role','status');mobileError.textContent='Image unavailable. Reopen this category to try again.';mobileError.hidden=true;mobile.after(mobileError);}
        const failed=()=>{mobile.hidden=true;mobileError.hidden=false};
        mobile.addEventListener('error',failed,{signal});
        mobile.addEventListener('load',()=>{mobile.hidden=false;mobileError.hidden=true},{signal});
        if(mobile.complete&&!mobile.naturalWidth) failed();
        button.addEventListener('click',()=>{
          const opening=button.getAttribute('aria-expanded')!=='true';
          items.forEach(other=>setOpen(other,other===item&&opening));
          if(opening){if(!mobileError.hidden){mobile.loading='eager';mobile.src=mobile.getAttribute('src')}changePhoto(item)}
          else {++revision;frame.setAttribute('aria-busy','false')}
        },{signal});
        button.addEventListener('pointerenter',()=>prepare(item),{signal});
        button.addEventListener('focus',()=>prepare(item),{signal});
      });
      main.addEventListener('error',()=>{failure.hidden=false},{signal});
      if(main.complete&&!main.naturalWidth) failure.hidden=false;
      const warm=()=>items.forEach(prepare);
      if('IntersectionObserver' in window){const observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){warm();observer.disconnect()}},{rootMargin:'800px 0px'});observer.observe(root);signal.addEventListener('abort',()=>observer.disconnect(),{once:true});}
      else warm();
      signal.addEventListener('abort',()=>{++revision;cache.clear()},{once:true});
    });
  }
  window.elySurfaceFinishing={init};
  init(document);
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:section:unload',event=>{controllers.forEach((controller,root)=>{if(event.target.contains(root)){controller.abort();controllers.delete(root)}})});
})();
